import React, { useState, useEffect } from 'react';


import './home.css';




import Header from '../../components/header/header';
import Footer from '../../components/footer/footer';




import {connect} from 'react-redux';
import * as actions from '../../store/property/actions';

import PropertyDreamBlock from '../../components/home/propertyDream';
import FeaturedProjectCommercial from '../../components/projects/featuredProjectCommercial';
import FeaturedProjectResidential from '../../components/projects/featuredProjectResidential';
import WebsiteServices from '../../components/home/websiteServices';
import Testimonials from '../../components/home/testimonials';
import HomePageFeaturedProperties from '../../components/property/featuredProperties';
import LatestProperties from '../../components/property/latestProperties';



const HomePage= ({}) => {   

   

    return (
        <div>
            <Header/> 
                <PropertyDreamBlock />
                <HomePageFeaturedProperties />
                <FeaturedProjectCommercial />
                <FeaturedProjectResidential />
                <WebsiteServices />
                <Testimonials />
                {/* <LatestProperties />  */}
            <Footer/>
        </div>
    )
}

function mapStateToProps(state) {
    return {
    };
}
  
function mapDispatchToProps(dispatch) {
    return {
        // getFeaturedProperties: (post) => dispatch(actions.getFeaturedProperties(post))
    };
}
  
export default connect(mapStateToProps, mapDispatchToProps)(HomePage);